import React from "react"

import { NO, YES, NONE, UNLIMITED, VALUE } from "const"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"


import { MtPackage } from "server/models"

import TableSelect from "../components/select"
import { styleOffset } from "./index"


const Rrs = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "riskSpaceModuleAccess",
            header: lang.riskSpaceModuleAccess,
            formatter: (packg: MtPackage) => {
                const { rrsRiskSpaceModuleAccess } = packg.settingsParsed
                return lang[rrsRiskSpaceModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { rrsRiskSpaceModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[rrsRiskSpaceModuleAccess]}
                        label={lang.riskSpaceModuleAccess}
                        property={{ rrsRiskSpaceModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "riskSpaceTemplates",
            header: lang.riskSpaceTemplates,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { rrsRiskSpaceTemplates, rrsRiskSpaceTemplatesValue } = packg.settingsParsed
                if (rrsRiskSpaceTemplates === NONE) return lang.none
                if (rrsRiskSpaceTemplates === VALUE) return rrsRiskSpaceTemplatesValue
                if (rrsRiskSpaceTemplates === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { rrsRiskSpaceTemplates, rrsRiskSpaceTemplatesValue } = packg.settingsParsed
                let title = ""
                if (rrsRiskSpaceTemplates === NONE) title = lang.none
                if (rrsRiskSpaceTemplates === VALUE) title = rrsRiskSpaceTemplatesValue.toString()
                if (rrsRiskSpaceTemplates === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.riskSpaceTemplates}
                        property={{ rrsRiskSpaceTemplates }}
                        propertyValue={{ rrsRiskSpaceTemplatesValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Rrs
